/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

// import { TextOverflow } from '@neo4j-ndl/react';
import { TextOverflow } from '../TextOverflow';

const Component = () => {
  const veryLongText =
    'The quick brown fox jumps over the lazy dog. Pack my box with five dozen liquor jugs. Waltz, bad nymph, for quick jigs vex. The five boxing wizards jump quickly. How vexingly quick daft zebras jump! Bright vixens jump; dozy fowl quack. Quick wafting zephyrs vex bold Jim.';

  return (
    <div className="n-max-w-80">
      <TextOverflow lines={3}>{veryLongText}</TextOverflow>
    </div>
  );
};

export default Component;
